import * as R from 'ramda';
import React from 'react';
import {of} from 'rxjs';
import {map, tap} from 'rxjs/operators';

import {gradingScales} from 'iss/service/GradingScaleService';
import ajax from 'iss/utils/ajax';
import {matchesLowerCase} from 'iss/utils/search';
import subscribeTo from 'iss/utils/subscriptionUtils';

export const evaluationForms = ajax.cache("/form", 10 * ajax.MINUTES);

export function searchForms({query, context}, page, pageSize, filterFun = false) {
  return evaluationForms.pipe(
    map(forms => {
      const matches = matchesLowerCase(query);
      const items = forms.filter(form =>
        matches(form.name) && matchesContext(context, form) && (!filterFun || filterFun(form))
      );
      const results = items.slice(page*pageSize, (page+1)*pageSize);
      return {results, totalResults: items.length};
    })
  );
}

function matchesContext(context, form) {
  if (!context) return true;
  if (context == 'QUALITY_ASSURANCE') return form.usedInSiteEvaluation;
  return form.personEvaluationContext === context;
}

export const getForm = R.memoizeWith((id, config) => String(id)+JSON.stringify(config), (id, config = {}) => {
  return ajax.cache("/form/"+id, 1 * ajax.MINUTES, config);
});

export function getHeadingsFromExcel(file, sheetname) {
  const formData  = new FormData();
  formData.append("file", file);
  return ajax.postMultipart("/form/excel?sheetname="+sheetname, formData);
}

export function createForm(form) {
  return ajax.postJson("/form", form)
    .pipe(
      tap(evaluationForms.clearCache),
      tap(gradingScales.clearCache)
    );
}

export function modifyForm(form) {
  return ajax.putJson("/form/"+form.id, form)
    .pipe(
      tap(evaluationForms.clearCache),
      tap(() => getForm(form.id).clearCache()),
      tap(gradingScales.clearCache)
    );
}

export function getFormsByGradingScaleId(id) {
  return ajax.getJson("/form/grading-scale/"+id);
}

export function changeFormGradingScale(formId, command) {
  return ajax.putJson("/form/"+formId+"/grading-scale", command);
}

export function subscribeToForm(WrappedComponent) {
  return function FormEditor({formId, ...props}) {
    let formObservable = formId ?
      getForm(formId) :
      of({
        name: "",
        description: "",
        isPublic: false,
        reportingStyle: "GRADE_AVERAGE",
        remarksFieldNames: [null, null],
        alternativeInfoFieldNames: [null, null],
        minQualityPercent: 0,
        maxQualityPercent: 100,
        usedInSiteEvaluation: true,
        personEvaluationContext: null,
        headings: [],
        serviceTypes: [],
        siteTypes: [],
        siteSizes: []
      });

    const SubscribedComponent = subscribeTo(formObservable, 'form', WrappedComponent);

    return <SubscribedComponent {...props} />;
  };
}



// WEBPACK FOOTER //
// ./modules/issFrontend/service/FormService.js